import { NgModule } from '@angular/core';
// eslint-disable-next-line no-restricted-imports -- allowed because this module is a library-local proxy for CmxWebComponentsModule.
import { CmxWebComponentsModule } from '@cmx-web-components/angular';

@NgModule({
  imports: [CmxWebComponentsModule],
  exports: [CmxWebComponentsModule],
})
export class ArkikWebComponentsModule {}
